import React from 'react';
import PropTypes from 'prop-types';
import assign from 'lodash/assign';
import get from 'lodash/get';
import keys from 'lodash/keys';

import { enumFromObject } from 'utils/enums';

const styles = {
  root: {
    position: 'absolute',
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    maxWidth: '70vw',
    width: 'max-content',
    borderRadius: 0,
  },
  bottom: {
    top: 'unset',
    bottom: '0!important',
  },
  top: {
    bottom: 'unset',
    top: '0!important',
  },
};

const DEFAULT_DELAY = 2000;

const POSITIONS = {
  TOP: 'top',
  BOTTOM: 'bottom',
};
const POSITIONS_ENUM = enumFromObject(POSITIONS);

const TYPES = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'danger',
  INFO: 'info',
};
const TYPES_ENUM = enumFromObject(TYPES);

const AlertLayout = ({ type, position, message }) => (
  <div
    className={`alert alert-${get(TYPES, type, TYPES.INFO)}`}
    style={assign(styles.root, get(styles, position, {}))}
    role="alert"
  >
    {message}
  </div>
);

class Alert extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      delay: props.delay || DEFAULT_DELAY,
      isVisible: props.isVisible,
    };
  }

  componentDidMount() {
    this.alertID = setTimeout(() => this.hide(), this.state.delay);
  }

  componentWillUnmount() {
    clearTimeout(this.alertID);
  }

  hide() {
    this.setState({ isVisible: false });
  }

  render() {
    return this.state.isVisible ? <AlertLayout {...this.props} /> : null;
  }
}

Alert.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  delay: PropTypes.number,
  type: PropTypes.oneOf([...keys(TYPES)]),
  position: PropTypes.oneOf([...keys(POSITIONS)]),
};

const AlertBranch = (props) => (props.isVisible ? <Alert {...props} /> : null);

export {
  POSITIONS_ENUM as POSITIONS,
  TYPES_ENUM as TYPES,
  AlertBranch as Alert,
};

export default AlertBranch;
